import API from "../services/api";

/** @typedef {{ id: string, text: string, priority: string, category: string, author: string, created_at: string }} OrgNoticeDto */

/** Active organisation notices for the Notice Board. */
export async function fetchNotices() {
  const res = await API.get("/notices");
  return Array.isArray(res.data) ? res.data : [];
}

/** Post a new notice (HR / Admin). */
export async function createNotice({ text, priority, category }) {
  const res = await API.post("/notices", {
    text,
    priority: String(priority || "normal").toLowerCase(),
    category: String(category || "general").toLowerCase(),
  });
  return res.data;
}

/** Soft-delete a notice (HR / Admin). */
export async function deleteNotice(noticeId) {
  await API.delete(`/notices/${noticeId}`);
}
